// @flow

import { observer } from "mobx-react";
import React from "react";

import AnimatedIconLoading from "app/components/AnimatedIconLoading/AnimatedIconLoading";

import "./VideoPublish.scss";

type Props = {
    onClick: Function,
    disabled: boolean
};

type State = {
    publishing: boolean
};

@observer
export default class VideoPublish extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { publishing: false };
    }

    handleClick(): void {
        this.setState({ publishing: true });
        this.props.onClick();
    }

    render() {
        const publishing = this.state.publishing;
        const classes = [
            "VideoPublish",
            `VideoPublish--${publishing ? "publishing" : "default"}`
        ];

        return (
            <button
                id="publish"
                className={classes.join(" ")}
                onClick={this.handleClick.bind(this)}
                disabled={this.props.disabled || publishing}
            >
                {this.renderContent()}
            </button>
        );
    }

    renderContent() {
        return this.state.publishing
            ? this.renderContentPublishing()
            : this.renderContentDefault();
    }

    renderContentDefault() {
        return (
            <div className="VideoPublish__content VideoPublish__content--default">
                <i className="fa fa-arrow-right" /> Publish
            </div>
        );
    }

    renderContentPublishing() {
        return (
            <div className="VideoPublish__content VideoPublish__content--publishing">
                <AnimatedIconLoading /> Publishing
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/VideoPublish/VideoPublish.js